// @flow
import React from 'react'
import NodeTags from './NodeTags'
import Checkbox from '../controls/Checkbox'

import type { Node } from '../types'

type Props = {|
  node: Node,
  onSelectChange: (Node) => any
|}

export default function MatchedNode(props: Props) {
  const { node, onSelectChange } = props

  return (
    <NodeTags.Node key={node.id}>
      <NodeTags.Option className="fs-Node__option" onClick={() => onSelectChange(node)}>
        <Checkbox checked={node.isSelected} compact label={node.label} />
      </NodeTags.Option>
    </NodeTags.Node>
  )
}
